"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnClick = void 0;
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var _react = require("react");
var _useProduct = require("./useProduct");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useOnClick = () => {
  const {
    analyticsData,
    brand,
    code,
    image,
    name,
    price,
    onProductBoxClick
  } = (0, _useProduct.useProduct)();
  return (0, _react.useCallback)(event => {
    const dispatchAnalytics = () => {
      const customEvent = new CustomEvent(ProductClickEvent.Name, {
        detail: {
          products: [{
            itemCode: code,
            formattedPrice: price?.currentFormatted,
            localName: name,
            globalName: '',
            localCategoryName: '',
            globalCategoryName: '',
            localBrandName: brand ?? '',
            globalBrandName: '',
            media: image ? [image] : []
          }],
          ...analyticsData
        }
      });
      window.dispatchEvent(customEvent);
    };
    dispatchAnalytics();
    if (onProductBoxClick) {
      event.preventDefault();
      event.stopPropagation();
      onProductBoxClick();
    }
  }, [analyticsData, brand, code, price?.currentFormatted, image, name, onProductBoxClick]);
};
exports.useOnClick = useOnClick;
